import styled from "styled-components";

const BundleCard = styled.div`
  width: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  background-color: ${({theme}) => theme.colors.background};
  position: relative;
  border: 2px solid ${({theme}) => theme.colors.brandDark};
  border-radius: 8px;
  padding: 12px;
  justify-content: space-between;
  font-family: var(--font-DINNextLTPro-Regular);

  .no-image-placeholder {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({theme}) => theme.colors.highlight};
  }

  .product-card__link-to {
    min-height: 0;
    display: flex;
    flex-direction: column;
    text-decoration: none;

    &:hover,
    &:focus {
      .product-card__media img {
        transform: scale(1.04);
      }
    }
  }
  
  .product-card__media {
    background: ${({theme}) => theme.colors.highlight};
    transition: background .2s ease-out;
    width: 100%;
    padding-bottom: 100%;
    position: relative;
    overflow: hidden;
    
    &.loaded-image {
      background: transparent;
      img,svg {
        opacity: 1;
      }
    }
    img, svg {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      max-height: 346px;
      object-fit: contain;
      transition: all ease-in-out .2s, opacity .3s ease-out;
      opacity: 0;
    }    
  }

  .product-card__details {
    margin-top: 1rem;
    padding-right: 8px;
    padding-left: 8px;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: baseline;
  }

  .product-card__price {
    display: flex;
    align-items: center;
    color: ${({theme}) => theme.colors.bundleGold};

    font-size: 36px;
    margin-right: 12px;
    @media (max-width: 859px) {
      font-size: 16px;
    }
  }

  .product-card__sale {
    margin-right: 24px;
    color: ${({theme}) => theme.colors.brandDark};

    font-size: 36px;
    @media (max-width: 859px) {
      font-size: 16px;
    }
  }

  .product-card__title {
    margin-bottom: auto;
    color: ${({theme}) => theme.colors.brandDark};
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    flex-shrink: 0;
    transition: var(--button-transition);
    grid-column-end: span 2;
    font-family: var(--font-DINNextLTPro-Regular);

    font-size: 26px;
    @media (max-width: 859px) {
      font-size: 16px;
    }
  }

  .product-card__percent {
    margin-top: .5rem;
    color: ${({theme}) => theme.colors.gray3};
    grid-column-end: span 2;
    display: inline-flex;
    flex-wrap: wrap;
  }
  
  .product-card__shop {
    margin-top: 1rem;
    padding-right: 8px;
    padding-left: 8px;
    width: 100%;
    display: flex;
    align-items: baseline;
    flex-shrink: 0;
    justify-content: center;
  }

  .product-card__button {
    position: relative;
    width: 100%;
    border: 3px solid ${({ theme }) => theme.colors.brandDark};
    border-radius: 35px;
    color: ${({ theme }) => theme.colors.brandDark};
    font-size: var(--type-scale-20);
    text-align: center;
    flex-shrink: 0;
    transition: all 0.2s;
    font-family: var(--font-DINNextLTPro-Regular);

    @media (max-width: 859px) {
      padding: 4px 6px 6px;
      width: 100%;
      font-size: 16px;
      border-radius: 14px;
    }
    @media (min-width: 860px) {
      max-width: 222px;
      padding: .75rem 16px;
    }

    &:hover,
    &:focus {
      outline: none;
      background-color: ${({ theme }) => theme.colors.brandDark};
      color: ${({ theme }) => theme.colors.background};
    }
    &:focus {
      outline: none;
    }
    &.is-loading {
      .product-card__button__copy {
        opacity: 0;
      }
        &:hover,
        &:focus {
          .product-card__button__load {
            .loading-spinner {
              .path {
                stroke: ${({ theme }) => theme.colors.white};
              }
            }
          }
        }
    }
  }

  .product-card__button__load {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .is-sold-out {
    background-color: ${({ theme }) => theme.colors.gray2};
    border: 1px solid ${({ theme }) => theme.colors.gray2};
    color: ${({ theme }) => theme.colors.white};
    cursor: not-allowed;
    &:hover {
      outline: none;
      background-color: ${({ theme }) => theme.colors.gray2};
      border-color: ${({ theme }) => theme.colors.gray2};
      color: ${({ theme }) => theme.colors.white};
    }
  }

`;

export default BundleCard;